
export default class Referrer {

    public static get() : Array<string> {
        
        const referrer = Referrer.getRaw();

        // handle samesite referrer
        if (referrer.indexOf(window.location.hostname) !== -1) {
            return [];
        }

        // make sure to return an empty set if the referrer
        // is an empty string
        if (referrer.length === 0) {
            return [];
        }

        // remove query parameters from the referrer
        // to avoid very large strings
        if (referrer.indexOf('?') !== -1) {
            return [referrer.substring(0, referrer.indexOf('?'))];
        }
        return [referrer];
    }

    public static getRaw() : string {
        if (window.__mock_referrer) {
            return window.__mock_referrer;
        }
        return document.referrer;
    }

}